import api from './api';

let scriptPromise = null;

const loadRazorpayScript = () => {
  if (window.Razorpay) return Promise.resolve(true);
  if (scriptPromise) return scriptPromise;
  scriptPromise = new Promise((resolve, reject) => {
    const s = document.createElement('script');
    s.src = 'https://checkout.razorpay.com/v1/checkout.js';
    s.onload = () => resolve(true);
    s.onerror = () => reject(new Error('Failed to load Razorpay'));
    document.body.appendChild(s);
  });
  return scriptPromise;
};

const randomMockId = () => `pay_mock_${Math.random().toString(36).slice(2, 12)}`;

/**
 * Starts a payment. In MOCK mode (no Razorpay keys configured) it auto-completes
 * the payment server-side so the flow is fully testable. When real keys are added,
 * it opens the Razorpay Checkout and verifies the signature.
 *
 * @returns Promise<{ status, invoice, mock }>
 */
export const startPayment = async ({ purpose, plan_id, swimmer_id, booking_id, amount, addon_count = 0, member_ids = [], notes, prefill = {} }) => {
  const { data: order } = await api.post('/payments/order', {
    purpose, plan_id, swimmer_id, booking_id, amount, addon_count, member_ids, notes,
  });

  // MOCK MODE — auto-complete
  if (order.mock) {
    const { data } = await api.post('/payments/verify', {
      razorpay_order_id: order.order_id,
      razorpay_payment_id: randomMockId(),
      razorpay_signature: 'mock',
    });
    return { ...data, mock: true };
  }

  // REAL MODE — open Razorpay Checkout
  await loadRazorpayScript();
  return new Promise((resolve, reject) => {
    const rzp = new window.Razorpay({
      key: order.key_id,
      amount: order.amount_paise,
      currency: order.currency,
      name: 'Hurupu Pools',
      description: order.label || purpose,
      order_id: order.order_id,
      prefill,
      theme: { color: '#0891b2' },
      handler: async (res) => {
        try {
          const { data } = await api.post('/payments/verify', {
            razorpay_order_id: res.razorpay_order_id,
            razorpay_payment_id: res.razorpay_payment_id,
            razorpay_signature: res.razorpay_signature,
          });
          resolve({ ...data, mock: false });
        } catch (err) {
          reject(err);
        }
      },
      modal: { ondismiss: () => reject(new Error('Payment cancelled')) },
    });
    rzp.open();
  });
};
